export default __webpack_public_path__ + "static/media/TagIcon.610a579e.svg";